import { PipelineStatus } from '../../const/PipelineTypes';

export const capitalized = (word?: string) => {
  if (!word) return '';
  if (word === PipelineStatus.InProgress) {
    return 'Running';
  }
  if (word === PipelineStatus.Canceled) {
    return 'Canceled';
  }
  if (word === PipelineStatus.Success) {
    return 'Successful';
  }
  if (word === PipelineStatus.Failure) {
    return 'Failed';
  }
  const newWord = word.charAt(0).toUpperCase() + word.slice(1);
  return newWord;
};

export const dateDifference = (date1: Date, date2: Date) => {
  const timeDifference = Math.abs(date2.getTime() - date1.getTime());

  const minutes = Math.floor(timeDifference / (1000 * 60));
  const hours = Math.floor(timeDifference / (1000 * 60 * 60));
  const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (years >= 1) {
    return years === 1 ? `${years} year ago` : `${years} years ago`;
  } else if (months >= 1) {
    return months === 1 ? `${months} month ago` : `${months} months ago`;
  } else if (weeks >= 1) {
    return weeks === 1 ? `${weeks} week ago` : `${weeks} weeks ago`;
  } else if (days >= 1) {
    return days === 1 ? `${days} day ago` : `${days} days ago`;
  } else if (hours >= 1) {
    return hours === 1 ? `${hours} hour ago` : `${hours} hours ago`;
  } else if (minutes >= 1) {
    return minutes === 1 ? `${minutes} minute ago` : `${minutes} minutes ago`;
  } else {
    return 'just now';
  }
};

export const getTextStatusColor = (status: PipelineStatus, uiTheme: boolean) => {
  switch (status.toLowerCase()) {
    case PipelineStatus.InProgress: // blue
      // return '#1174E6';
      return uiTheme ? '#0069c2' : '#008CFF';
    case PipelineStatus.Completed: // green
      return '#329864';
    case PipelineStatus.Success: // green
      return '#329864';
    case PipelineStatus.Failure: // red
      return uiTheme ? '#6A6A6A' : '#8B8B8B';
    case PipelineStatus.Canceled: // grey
      // return '#878787';
      return uiTheme ? '#6A6A6A' : '#8B8B8B';
    case PipelineStatus.Pending: // orange
      return '#D46617';
    case PipelineStatus.Banned: // grey
      return '#878787';
    case PipelineStatus.Manual: // orange/yellow for manual action required
      return '#D46617';
    default:
      return '#878787';
  }
};

export const getBackgroundStatusColor = (status: PipelineStatus, uiTheme: boolean) => {
  switch (status.toLowerCase()) {
    case PipelineStatus.InProgress: // blue
      //return '#1174E6';
      return uiTheme ? 'rgb(0,84,153, 0.2)' : 'rgb(0,84,153, 0.3)';
    case PipelineStatus.Completed: // green
      return '#329864';
    case PipelineStatus.Success: // green rgb(40,137,100)
      return uiTheme ? 'rgb(40, 137, 100, 0.2)' : 'rgb(40,137,100, 0.2)';
    case PipelineStatus.Failure: // red
      return uiTheme ? 'rgb(148, 34, 40, 0.2)' : 'rgb(148,34,40, 0.3)';
    case PipelineStatus.Canceled: // grey
      //return '#878787';
      return uiTheme ? 'rgb(242,242,242,0.3)' : '#242424';
    case PipelineStatus.Pending: // orange
      return '#D46617';
    case PipelineStatus.Banned: // grey
      return '#878787';
    case PipelineStatus.Manual: // orange/yellow for manual action required
      return '#D46617';
    default:
      return '#878787';
  }
};

export const getStatusColor = (status: PipelineStatus, uiTheme: boolean) => {
  switch (status.toLowerCase()) {
    case PipelineStatus.InProgress: // blue
      //return '#1174E6';
      return uiTheme ? '#0069c2' : '#008CFF';
    case PipelineStatus.Completed: // green
      return '#329864';
    case PipelineStatus.Success: // green
      return '#329864';
    case PipelineStatus.Failure: // red
      return uiTheme ? '#ED0E00' : '#DC2D37';
    case PipelineStatus.Canceled: // grey 6A6A6A
      return uiTheme ? '#6A6A6A' : '#8b8b8b';
    case PipelineStatus.Pending: // orange
      return '#878787';
    case PipelineStatus.Banned: // grey
      return '#D46617';
    case PipelineStatus.Manual:
      return '#FAD22D';
    case PipelineStatus.Warning:
      return '#E66E19';
    case PipelineStatus.Aborted:
      return '#D84B92';
    case PipelineStatus.Paused:
      return '#BA9EF8';
    default:
      return '#878787';
  }
};
